import en from './en'
import pt from './pt'

export default{
	pt, 
	en
}


// WEBPACK FOOTER //
// ./src/messages/index.js